<template>
<div class="yo-text-n " style="margin:20px 0;padding:0;" v-if="false">


   <div class="row white pad" style="">
      <a href="/editoria/" class="col s12 m4 yo-bg-center " style="background-color:#ADD256;min-height:190px;" :style="{'background-image': `url(${require('../assets/bg-aree.png')})`}">
         <div class="yo-align-center arnoprodisplay yo-text-xxl white" style="padding-top:118px;line-height:18px;">BioMedia</div>
         <div class="yo-align-center yo-text-n yo-text-bold white" style="">Editore</div>
      </a>  

      
      <a href="https://familyhealth.it/" target="_blank" class="col s12 m4 yo-bg-center" style="background-color:#004680;min-height:190px;" :style="{'background-image': `url(${require('../assets/bg-aree.png')})`}">
         <div class="yo-align-center arnoprodisplay yo-text-xxl white" style="padding-top:118px;line-height:18px;">BioMedia</div>
         <div class="yo-align-center yo-text-n yo-text-bold white" style="">FamilyHealth</div>
      </a>
      

      <a href="/645-2/" class="col s12  m4 yo-bg-center" style="background-color:#FCCDE8;min-height:190px;" :style="{'background-image': `url(${require('../assets/bg-aree.png')})`}">
         <div class="yo-align-center arnoprodisplay yo-text-xxl black" style="padding-top:118px;line-height:18px;">BioMedia</div>
         <div class="yo-align-center yo-text-n yo-text-bold  black" style="">Travel</div>
      </a>
   </div>


   
</div>
</template>

<script>



export default {
   name: 'home',
   components: {

   }
}
</script>


<style>

</style>



// WEBPACK FOOTER //
// src/components/Aree.vue